<script>
  import Filter from "../../Filter/Filter.svelte";
  import { onMount } from "svelte";
  import { getOrderFilters, ORDER_FILTER_TYPE } from "../../Filter/static";
  import BasicFilter from "../BasicFilter.svelte";
  import Searchbox from "../../Common/Searchbox.svelte";
  import { calcGroupingForTimeRange } from "../../Common/tools";
  import StatsSubscriptions from "../Stats/StatsSubscriptions.svelte";
  import SubscriptionsTable from "./SubscriptionsTable.svelte";
  import ProductsTable from "./ProductsTable.svelte";
  import {External, M} from "../../external";

  export let options = null;

  let grouping = "monthly";
  let firstOrderTime = 0;
  let filterInstance;
  let filters = [];
  let instance = null;
  let tab = "-";
  let disabledCrmProperties = [/*-1, -2,*/ "utm_source", "utm_campaign", "utm_medium", "utm_content", "utm_term"];
  let tableDetails = {
    count: 0,
    label: ""
  };
  let activeFunnelId = options && options.funnel ? options.funnel : null;
  let activePeriod = {
    label: M.ALL_TIME_FILTER,
    id: "all",
    from: null,
    to: null
  };
  let searchPhrase = "";

  let orderFilters = getOrderFilters([
    //ORDER_FILTER_TYPE.NAME,
    //ORDER_FILTER_TYPE.EMAIL,
    //   ORDER_FILTER_TYPE.CREATED,
    //ORDER_FILTER_TYPE.TOTAL,
    ORDER_FILTER_TYPE.PRODUCT,
    //   ORDER_FILTER_TYPE.FUNNEL,
    //ORDER_FILTER_TYPE.STATUS,
    //ORDER_FILTER_TYPE.PAID,
    ORDER_FILTER_TYPE.UTM_SOURCE,
    ORDER_FILTER_TYPE.UTM_CAMPAIGN,
    ORDER_FILTER_TYPE.UTM_MEDIUM,
    ORDER_FILTER_TYPE.UTM_CONTENT,
    ORDER_FILTER_TYPE.UTM_TERM
  ]);

  let onFilterChange = () => {
    grouping = calcGroupingForTimeRange(firstOrderTime, activePeriod.from, activePeriod.to);
    setTimeout(() => {
      instance.reload();
    }, 1);
  };

  let changeTab = (newTab) => {
    tab = newTab;
  };

  let onTableLoaded = (event) => {
    let details = event.detail || {};
    tableDetails = {
      count: details.count || 0,
      label: details.label || ""
    };
  };

  let onBasicFilterChange = (event) => {
    activePeriod = event.detail.period;
    activeFunnelId = event.detail.funnel.id;
    onFilterChange();
  };

  let showMoreOptions = () => {
    const items = [
      {
        text: M.EXPORT_ORDERS,
        icon: "fa-cloud-download",
        tag: "export"
      }
    ];
    if (tab !== "archived") {
      items.push({
        text: M.ARCHIEVE_ORDERS,
        icon: "fa-trash",
        tag: "archive"
      });
    }

    External.Tools.showTooltipOptions(External.$(event.target), items, function (target, idx, text, tag) {
      switch (tag) {
        case "export":
          instance.startExport();
          break;
        case "archive":
          instance.archive();
          break;
      }
    });
  };

  let showSearch = (event) => {
    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target),
      customClass: "floating-popup-list",
      action: {
        onShow: function (popup, ui) {
          let component = new Searchbox({
            target: ui.find(".bound-popup")[0],
            props: {
              term: searchPhrase,
              onSearch: function (term) {
                searchPhrase = term;
                onFilterChange();
              }
            }
          });
          popup.component = component;
        },
        onHide: function (popup) {
          if (popup.component) {
            popup.component.$destroy();
            popup.component = null;
          }
        }
      }
    });
  };

  let clearSearch = () => {
    searchPhrase = "";
    onFilterChange();
  };

  onMount(function () {
    firstOrderTime = External.Website.firstOrderTime || External.createdTime;
    grouping = calcGroupingForTimeRange(firstOrderTime, activePeriod.from, activePeriod.to);
    tab = "analytics";
  });
</script>

<div class="account-settings overflow store-products flex-1 horizontal-flex-table col20" style="font-family: 'Roboto';">
  <div class="top-background-wrapper narrow-top-background" style="padding-top:15px;">
    <div class="top-background filter-wrapper-outer">
      <Filter
        enableOR={false}
        bind:this={filterInstance}
        bind:filters
        enableSaveSegment={false}
        onChange={onFilterChange}
        disabledCrmProperties={disabledCrmProperties}
        customFilters={orderFilters} />
    </div>
    <div class="top-background">
      <div class="text-wrapper f-left col20 flex align-center space-between">
        <div class="flex-centered flex-col-mobile f-left">
          <div class="flex align-center justify-center">
            {#if tab === "subscriptions"}
              <h2 class="crm-title f-left crm-title-bigger">{M.SUBSCRIPTIONS}<i class="fa fa-circle" /></h2>
            {:else if tab === "analytics"}
              <h2 class="crm-title f-left crm-title-bigger">{M.ANALYTICS}</h2>
            {:else if tab === "churn"}
              <h2 class="crm-title f-left crm-title-bigger">{M.CHURN_LBL}<i class="fa fa-circle" /></h2>
            {:else if tab === "products"}
              <h2 class="crm-title f-left crm-title-bigger">{M.PRODUCTS}<i class="fa fa-circle" /></h2>
            {/if}

            {#if tab !== "analytics"}
              <h2 class="crm-title f-left crm-title-bigger">
                {tableDetails.count}
                {#if tab === "products"}
                  {tableDetails.count === 1 ? M.PRODUCT : M.PRODUCTS}
                {:else}
                  {tableDetails.count === 1 ? M.SUBSCRIPTION : M.SUBSCRIPTIONS}
                {/if}
              </h2>
            {/if}
          </div>
          <BasicFilter on:change={(event) => onBasicFilterChange(event)} period={activePeriod} funnel={activeFunnelId} />
        </div>
        {#if tab !== "analytics"}
          <div class="f-right flex-centered mobile-hidden">
            <div class="flex align-center search-inline-wrapper">
              {#if searchPhrase}
                <a on:click={clearSearch} class="remove-search-btn flex align-center mr-5 rounded-effect">
                  <p class="f-left">{M.CLEAR}</p>
                  <p class="material-icons-outlined ml-5 f-left">cancel</p>
                </a>
              {/if}
              <a on:click={(event) => showSearch(event)} class="circle-button blue rounded-effect flex align-center justify-center">
                <span class="material-icons-outlined">search</span>
              </a>
            </div>
            <!--
          <a class="crm-option" on:click={showMoreOptions} style="margin-left: 10px; padding-right: 33px;">
            {M.MORE}
            <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
              <path d="M4 6l4 4 4-4H4z" />
            </svg>
          </a>
          -->
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="content-wrapper horizontal-flex-table">
    <div class="sections-wrapper members-wrapper horizontal-flex-table">
      <div class="section-bg members-wrapper products-wrapper crm-table-outer">
        <ul class="upper-navigation upper-navigation-full mb-15 mt-15">
          <li><a class:active={tab === "analytics"} on:click|preventDefault={() => changeTab("analytics")}>{M.ANALYTICS}</a></li>
          <li><a class:active={tab === "subscriptions"} on:click|preventDefault={() => changeTab("subscriptions")}>{M.SUBSCRIPTIONS}</a></li>
          <li><a class:active={tab === "churn"} on:click|preventDefault={() => changeTab("churn")}>{M.CHURN_LBL}</a></li>
          <li><a class:active={tab === "products"} on:click|preventDefault={() => changeTab("products")}>{M.SUBSCRIPTION_PRODUCTS}</a></li>
        </ul>

        {#if tab === "analytics"}
          <div class="col20 f-left mb-55"><StatsSubscriptions bind:this={instance} filters={filters} grouping={grouping} funnel={activeFunnelId} period={activePeriod} /></div>
        {:else if tab === "subscriptions"}
          <SubscriptionsTable bind:this={instance} filters={filters} period={activePeriod} funnel={activeFunnelId} search={searchPhrase} on:itemsloaded={onTableLoaded} />
        {:else if tab === "churn"}
          <SubscriptionsTable
            bind:this={instance}
            filters={filters}
            period={activePeriod}
            funnel={activeFunnelId}
            search={searchPhrase}
            showArchived={true}
            on:itemsloaded={onTableLoaded} />
        {:else if tab === "products"}
          <ProductsTable
            bind:this={instance}
            filters={filters}
            period={activePeriod}
            funnel={activeFunnelId}
            search={searchPhrase}
            showArchived={true}
            on:itemsloaded={onTableLoaded} />
        {/if}
      </div>
    </div>
  </div>
</div>
